import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5cee72df"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex cos-both-form-item" }
const _hoisted_2 = { class: "flex cos-both-form-item" }
const _hoisted_3 = { style: {"font-weight":"bold","padding-bottom":"4px"} }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Warehouse Management Team will confirm in OA", -1))
const _hoisted_5 = { class: "flex cos-both-form-item" }
const _hoisted_6 = { class: "flex cos-both-form-item" }
const _hoisted_7 = { class: "flex cos-both-form-item" }

import { ref, reactive, computed, onBeforeMount, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { layoutTags } from '@dc-platform/dc-interaction'
import { DcConfirm, message } from '@dc-platform/dc-components'
import { cloneDeep } from 'lodash-es'
import { ofbuContactValidate, concatNameValidate, selectForNumberValidate } from '@/utils/validate'
import CustomerArea from '@/components/CustomerArea'
import MultipleItem from '@/components/CosViewContent/multipleItem.vue'
import CosSingleDateTimePicker from '@/components/CosSingleDateTimePicker/index.vue'
import CustomerAreaCascader from '@/components/CustomerAreaCascader/index.vue'
import ParamCodeCascader from '@/components/CosCascader/components/ParamCodeCascader.vue'
import { clueTypeEnum } from '@/views/overseasSales/clueManage/dataConfig'
import { linkRoleTypeEnum, genderEnum, flagEnum } from '@/views/overseasSales/commonEnum/dataConfig'
import { listByParamCodes, fetchUsersByWorkCode } from '@/api/common'
import { salesClueCreate, salesClueActivate, salesClueEdit, salesClueDetail } from '@/api/overseasSales/clueManage'
import calc from '@/utils/calc'
import { initObjectVal, clearInvalid, paramCodesDataFilter } from '@/utils/index'
import type { FormInstance } from 'ant-design-vue'
import type { Rule } from 'ant-design-vue/es/form'
import type { ParamCodeItem } from '@/typings/common'
import type { FbuSalesClueEditParams } from '@/typings/api/clueManage'
import { clear } from '@/hooks/addressArrValidate'
import { useI18n } from 'vue-i18n'
import UploadFile from '@/components/UploadFile'
import { ExclamationCircleOutlined } from '@ant-design/icons-vue'
import { queryMarketActivityList } from '@/api/marketing/marketingManage'
import CosSelect from '@/components/Antd/CosSelect/index.vue'
import { getTreeIds } from '@/utils/index'


const __default__ = { name: 'DetailForm' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  value: Object,
  isEdit: {
    type: Boolean,
    required: true
  },
  type: {
    type: String,
    required: true,
    validator(value: string) {
      return ['add', 'edit', 'view'].includes(value)
    }
  },
  clueTypeDisabled: {
    type: Boolean,
    default: false
  },
  resetValue: {
    type: [Object, Array]
  }
},
  setup(__props) {

const { t } = useI18n()
const router = useRouter()
const route = useRoute()

const props = __props

const permissionPage = computed(() => {
  return props.type === 'add'
    ? { save: 'ofbu_clue_add_btn' }
    : { edit: 'ofbu_clue_edit_btn', save: 'ofbu_clue_edit_btn' }
})
const initForm = reactive<FbuSalesClueEditParams.RootObject>({
  contact: {},
  business:
    {
      demandInfo:
        { warehouses: [{}] },
      saleInfo: [{}],
      quotationInfo: { details: [{}] },
      contractInfo: { fixedCredit: {}, registrationFee: {}, monthlyMaintenanceFee: {} }
    },
  visitAddress: [{}]
})

const queryClueId = computed(() => route.query.clueId as string)
// 线索类型枚举
const clueTypeEnumComputed = computed(() => {
  const addList = clueTypeEnum.filter((item) => item.value === 1 || item.value === 2)
  const otherList = clueTypeEnum.filter((item) => item.value)
  return props.type === 'add' ? addList : otherList
})
const paramCodeData: {
  [key: string]: ParamCodeItem[]
} = reactive({
  ofbu_invalid_reason: [], // 无效原因
  ofbu_marketing_activity: [], // 关联市场活动
  ofbu_area_code: [], // 手机区号
  ofbu_service_demand: [], // 服务需求
  ofbu_important: [], // 潜在收入
  ofbu_client_type: [], // 客户类型
  ofbu_business_type: [], // 客户业务类型
  ofbu_demand_info: [], // 需求海外仓
  ofbu_sale_platform: [], // 在售电商平台
  ofbu_sales_category: [], // 销售品类
  ofbu_product_type: [], // 产品货型
  ofbu_currency: [], // 币种
  ofbu_sales_channel: [], // 销售渠道
  ofbu_services_standard: [], // 服务标准
  ofbu_shipments: [], // 发货量（月）
  ofbu_sku_unit: [], // SKU单位
  ofbu_quotation_type: [], // 价格类型
  ofbu_service_type: [], // 尾程服务需求
  ofbu_service_body: [], // 服务主体（服务公司）
  ofbu_payment_type: [], // 付款方式
  ofbu_billing_term: [], // 出账周期
  ofbu_inbound_package_type: [] // 入库包装方式
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_ofbu',
    paramCodes: [
      'ofbu_invalid_reason',
      'ofbu_marketing_activity',
      'ofbu_area_code',
      'ofbu_service_demand',
      'ofbu_important',
      'ofbu_client_type',
      'ofbu_business_type',
      'ofbu_demand_info',
      'ofbu_sale_platform',
      'ofbu_sales_category',
      'ofbu_product_type',
      'ofbu_sign_in_address_label',
      'ofbu_currency',
      'ofbu_sales_channel',
      'ofbu_services_standard',
      'ofbu_shipments',
      'ofbu_sku_unit',
      'ofbu_quotation_type',
      'ofbu_service_type',
      'ofbu_service_body',
      'ofbu_payment_type',
      'ofbu_billing_term',
      'ofbu_inbound_package_type',
      'ofbu_source_channel'
    ]
  }).then((res) => {
    if (props.type !== 'view') {
      // 递归过滤业务参数状态
      res.data = paramCodesDataFilter(res.data, 0)
    }
    Object.assign(paramCodeData, res.data)
  })
}
const getMarketOption = () => {
  queryMarketActivityList({ subdomain: 'cos_ofbu' }).then((res) => {
    if (res.data && res.data.length) {
      marketOptions.value = res.data.map((item: any) => ({
        label: item.activityName,
        value: item.id
      }))
    }
  })
}
onBeforeMount(() => {
  getByParamCodes()
  getMarketOption()
})
// 获取当前用户的信息
const getFollowerInfo = (workCode: string) => {
  const employeeList = [workCode]
  fetchUsersByWorkCode({ employeeList }).then((res) => {
    const [followerInfo] = res.data
    if (followerInfo && followerInfo.fbuCustomerRegion != null) {
      dataForm.customerRegion = followerInfo.fbuCustomerRegion
    } else {
      dataForm.customerRegion = undefined
      setTimeout(() => formRef.value?.clearValidate('customerRegion'))
    }
  })
}

const formRef = ref<FormInstance>()
const dataForm = reactive<FbuSalesClueEditParams.RootObject>(cloneDeep(initForm))
const clueType = ref(false)
const marketRequired = ref<boolean>()
const invalidClue = ref(false)
const isPerfect = ref(false)
const marketOptions = ref<any[]>([])
const formRules: Record<string, Rule[]> = {
  select: [{ required: true, message: t('common.pleaseSelect') }],
  input: [{ required: true, message: t('common.pleaseInput') }],
  channel: [{ required: true, message: t('common.pleaseSelect') }],
  clueType: [{ required: true, validator: selectForNumberValidate, message: t('common.pleaseSelect') }],
  customerOffice: [{ required: true, message: t('common.pleaseSelect') }],
  futureContactTime: [{ required: true, message: t('common.pleaseSelect') }],
  follower: [{ required: true, message: t('common.pleaseSelect') }],
  customerName: [{ required: true, message: t('common.pleaseInput') }],
  industrialBeltName: [{ required: true, message: t('common.pleaseInput') }],
  invalidId: [{ required: true, validator: selectForNumberValidate, message: t('common.pleaseSelect') }],
  contactType: [{ required: true, validator: selectForNumberValidate, message: t('common.pleaseSelect') }],
  lastName: [
    { required: true, message: t('common.pleaseInput') },
    {
      validator: concatNameValidate
    }
  ],
  contact: [{ validator: (rule: any, value: any) => ofbuContactValidate(rule, value, dataForm, formRef.value) }]
}
watch(
  () => route.query.isPerfect,
  (val) => {
    if (val === 'required') {
      isPerfect.value = true
    }
  },
  { immediate: true }
)
watch(
  () => dataForm.clueType,
  (val) => {
    // 控制未来线索必填校验
    if (val === 1) {
      clueType.value = true
    } else {
      clueType.value = false
      dataForm.futureContactTime = undefined
    }

    // 控制无效线索必填校验
    if (val === 3) {
      invalidClue.value = true
    } else {
      invalidClue.value = false
      dataForm.invalidId = undefined
    }
  },
  { immediate: true }
)
watch(
  () => dataForm.channel,
  (val) => {
    // 目前当【线索来源】选择【市场活动1809、市场投放1811、市场渠道（合作伙伴）1810】时，关联市场该字段必填
    // 但是线索来源是属于层级的，该三个来源下还有一层，无法全部判断，故此处就只判断非必填的状态
    if (val) {
      const labelIds = getTreeIds(paramCodeData.ofbu_source_channel || [], val)
      marketRequired.value = labelIds.includes(1809) || labelIds.includes(1810) || labelIds.includes(1811)
    } else {
      marketRequired.value = false
    }
  },
  { immediate: true }
)
watch(
  () => props.value,
  (val) => {
    if (val) {
      // 处理后端返回 null、0、空数组的问题
      const formVal = {
        ...val
      }
      initObjectVal(formVal, initForm)
      // 处理需求海外仓和totalAmount 把0=》undefined
      if (!formVal.business.demandInfo.totalAmount) {
        formVal.business.demandInfo.totalAmount = undefined
      }
      if (formVal.business.demandInfo.warehouses.length) {
        formVal.business.demandInfo.warehouses.forEach((item: any) => {
          if (!item) return
          if (item.warehouseId != null) {
            item.warehouseId = item.warehouseId || undefined
          }
          if (item.amount === null) item.amount = undefined
        })
      }
      if (formVal.business.saleInfo.length) {
        formVal.business.saleInfo.forEach((item: any) => {
          if (!item) return
          if (item.salePlatformId != null) {
            item.salePlatformId = item.salePlatformId || undefined
          }
          if (item.percent === null) item.percent = undefined
        })
      }
      Object.assign(dataForm, clearInvalid(formVal))
    }
  },
  { immediate: true, deep: true }
)
const handleFollowerChange = (val: any) => {
  if (val && props.type === 'add') getFollowerInfo(val)
}

const goBack = () => {
  if (location.hostname === 'localhost') {
    router.back()
  } else {
    layoutTags.close()
  }
}

const checkValidate = (rule: any, value: number | string, arr: any, name: string, message: string) => {
  if (isPerfect.value && value == null) return Promise.reject(new Error(message))
  const index = rule.field.split('.').slice(-2)[0] * 1
  const list = arr || []
  let key = list[index][name]
  if (name === 'warehouseId' && key === -9) key = undefined
  if (key != null && key !== '' && (!value || value === -9)) {
    return Promise.reject(new Error(message))
  } else {
    return Promise.resolve()
  }
}
const percentValidate = async (rule: any, value: number) => {
  if (isPerfect.value && value == null) return Promise.reject(new Error(t('common.pleaseInput')))
  const index = rule.field.split('.').slice(-2)[0] * 1
  const key = dataForm.business.saleInfo?.[index].salePlatformId
  if (key && key !== -9 && value == null) {
    return Promise.reject(new Error(t('common.pleaseInput')))
  }
  const result = dataForm.business.saleInfo?.reduce((prev: number, curr: any) => calc.Add(prev, curr.percent || 0), 0)
  if (value && result !== 100) {
    return Promise.reject(new Error(t('clue.saleInfoPercentValidate')))
  } else {
    return Promise.resolve()
  }
}

const amount = computed(() => {
  const result = dataForm.business.demandInfo.warehouses?.reduce((sum, item) => {
    return calc.Add(sum, item.amount || 0)
  }, 0)
  return result || ''
})
const handleQuotationAdd = () => {
  dataForm.business.quotationInfo?.details?.push({ })
}
const handleQuotationDel = (index: number) => {
  dataForm.business.quotationInfo?.details?.splice(index, 1)
}
const quotationAndBusinessChange = ref<boolean>(false)

watch(
  () => dataForm.business.contractInfo?.paymentType,
  (newValue, oldValue) => {
    if (newValue === 3504 || newValue === 3473) {
      if (!dataForm.business.contractInfo.paymentTerm) {
        dataForm.business.contractInfo.paymentTerm = '10'
      }
    }
  },
  { immediate: true, deep: true }
)
// 当【价格类型】选择为【公布价】且【业务类型】选择为【仓储服务】或【头程+仓储】时
watch(
  () => [dataForm.business.quotationInfo.quotationType, dataForm.business.businessTypeSelect],
  (newValue, oldValue) => {
    const [quotationType, businessTypeSelect] = newValue
    quotationAndBusinessChange.value = (quotationType === 3468) &&
      (businessTypeSelect === 3438 || businessTypeSelect === 3441)
  },
  { immediate: true, deep: true }
)
const loading = ref(false)
const handleSubmit = async () => {
  try {
    loading.value = true
    const params = cloneDeep(dataForm)
    const { visitAddress } = params
    params.visitAddress = clear(visitAddress, ['addressName', 'geoPoint'])
    // 新增、编辑的格式和详情不同、多传attrList
    if (JSON.stringify(params.visitAddress) === '[{}]') {
      params.visitAddress = { attrList: [] }
    } else {
      params.visitAddress = { attrList: params.visitAddress }
    }
    // 联系方式为空的字段需要删除，否则接口会报错
    // for (const key in params.contact) {
    //   if (params.contact[key] === '' || params.contact[key] == null) delete params.contact[key]
    // }
    params.business.demandInfo.warehouses = params.business.demandInfo.warehouses?.filter((item: any) => {
      return item.warehouseId != null && item.amount != null
    })
    params.business.saleInfo = params.business.saleInfo?.filter((item: any) => {
      return item.salePlatformId != null && item.percent != null
    })
    // 清空产业带名称
    if (params.business.industrialBeltFlag !== 1) {
      params.business.industrialBeltName = ''
    }
    if (params.business.businessTypeSelect) {
      params.business.businessType = [params.business.businessTypeSelect]
      params.business.businessTypeSelect = undefined
    }
    if (queryClueId.value) {
      params.id = queryClueId.value
      if (params.customerRegion === undefined) {
        params.customerRegion = ''
      }
      await salesClueEdit(params)
      message.success(t('tips.editSuccess'))
      goBack()
    } else {
      const data = await salesClueCreate(params, { custom: { errorMsg: false } })
      if (data.code === 200) {
        message.success(t('tips.addSuccess'))
        goBack()
      } else if (data.code === 13000059) {
        DcConfirm.warning({
          title: t('tips.beNotified'),
          content: data.message,
          cancelText: t('btn.cancel'),
          okText: t('btn.continue'),
          onOk() {
            salesClueActivate(params).then(() => {
              message.success(t('clue.claimedSuccess'))
              goBack()
            })
          }
        })
      } else {
        message.error(data.message)
      }
    }
  } catch (errorInfo: any) {
    loading.value = false
    formRef.value?.scrollToField(errorInfo.errorFields[0].name.toString())
  }
  loading.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_CosInput = _resolveComponent("CosInput")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_a_input_group = _resolveComponent("a-input-group")!
  const _component_CosInputNumber = _resolveComponent("CosInputNumber")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_ParamCodesSelect = _resolveComponent("ParamCodesSelect")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_UserSelect = _resolveComponent("UserSelect")!
  const _component_dc_layout_card = _resolveComponent("dc-layout-card")!
  const _component_CosRadioGroup = _resolveComponent("CosRadioGroup")!
  const _component_CosTextarea = _resolveComponent("CosTextarea")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_cos_footer_button = _resolveComponent("cos-footer-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_form, {
      ref_key: "formRef",
      ref: formRef,
      model: dataForm,
      rules: formRules,
      autocomplete: "off",
      scrollToFirstError: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_dc_layout_card, {
          title: _unref(t)('common.baseTitle'),
          span: 6
        }, {
          default: _withCtx(() => [
            _createVNode(_component_dc_form_item, {
              name: "customerName",
              label: _unref(t)('clue.customerName')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosInput, {
                  value: dataForm.customerName,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((dataForm.customerName) = $event)),
                  maxlength: 100,
                  disabled: !props.isEdit,
                  view: props.type === 'view'
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["label"]),
            (props.type === 'view')
              ? (_openBlock(), _createBlock(_component_dc_form_item, {
                  key: 0,
                  name: "customerName",
                  label: _unref(t)('clue.clueId')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CosInput, {
                      value: dataForm.clueId,
                      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((dataForm.clueId) = $event)),
                      disabled: !props.isEdit,
                      view: ""
                    }, null, 8, ["value", "disabled"])
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true),
            _createVNode(_component_dc_form_item, {
              name: "channel",
              label: _unref(t)('clue.clueChannel'),
              class: "form-item_compact"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_group, {
                  compact: "",
                  class: "cos-view-input-group"
                }, {
                  default: _withCtx(() => [
                    _createVNode(ParamCodeCascader, {
                      value: dataForm.channel,
                      "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((dataForm.channel) = $event)),
                      cosDes: dataForm.channelExplain,
                      appId: "cos_ofbu",
                      paramCode: "ofbu_source_channel",
                      status: props.type === 'view' ? undefined : 0,
                      disabled: !props.isEdit,
                      view: props.type === 'view',
                      style: {"width":"33%"}
                    }, null, 8, ["value", "cosDes", "status", "disabled", "view"]),
                    _createVNode(_component_dc_form_item, {
                      name: "channelExplain",
                      span: 24,
                      style: {"width":"67%"},
                      class: "last-compact"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_CosInput, {
                          value: dataForm.channelExplain,
                          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((dataForm.channelExplain) = $event)),
                          maxlength: 100,
                          disabled: !props.isEdit,
                          view: props.type === 'view'
                        }, null, 8, ["value", "disabled", "view"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_dc_form_item, {
              name: "clueType",
              label: _unref(t)('clue.clueType')
            }, {
              default: _withCtx(() => [
                _createVNode(CosSelect, {
                  value: dataForm.clueType,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((dataForm.clueType) = $event)),
                  options: clueTypeEnumComputed.value,
                  disabled: !props.isEdit || props.clueTypeDisabled,
                  view: props.type === 'view',
                  allowClear: ""
                }, null, 8, ["value", "options", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_dc_form_item, {
              name: "customerOffice",
              label: _unref(t)('clue.customerOffice'),
              rules: formRules.customerOffice
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(CustomerArea), {
                  value: dataForm.customerOffice,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((dataForm.customerOffice) = $event)),
                  "change-on-select": "",
                  showSearch: "",
                  disabled: !props.isEdit,
                  view: props.type === 'view'
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["label", "rules"]),
            _createVNode(_component_dc_form_item, {
              name: "customerWebsite",
              label: _unref(t)('clue.officialWeb')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosInput, {
                  value: dataForm.customerWebsite,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((dataForm.customerWebsite) = $event)),
                  valueModifiers: { trim: true },
                  maxlength: 200,
                  disabled: !props.isEdit,
                  view: props.type === 'view'
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_dc_form_item, {
              name: "registerEmail",
              label: _unref(t)('clue.regEmail')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosInput, {
                  value: dataForm.registerEmail,
                  "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((dataForm.registerEmail) = $event)),
                  valueModifiers: { trim: true },
                  maxlength: 200,
                  disabled: !props.isEdit,
                  view: props.type === 'view'
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_dc_form_item, {
              name: "customerAddress",
              label: _unref(t)('clue.customerAddress')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosInput, {
                  value: dataForm.customerAddress,
                  "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((dataForm.customerAddress) = $event)),
                  valueModifiers: { trim: true },
                  maxlength: 200,
                  disabled: !props.isEdit,
                  view: props.type === 'view'
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_dc_form_item, {
              name: "activityQrcodeId",
              label: _unref(t)('clue.marketActivity'),
              rules: [{ required: marketRequired.value, message: _unref(t)('common.pleaseSelect') }]
            }, {
              default: _withCtx(() => [
                _createVNode(CosSelect, {
                  value: dataForm.activityQrcodeId,
                  "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((dataForm.activityQrcodeId) = $event)),
                  options: marketOptions.value,
                  disabled: !props.isEdit,
                  view: props.type === 'view',
                  allowClear: "",
                  optionFilterProp: "label",
                  showSearch: ""
                }, null, 8, ["value", "options", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["label", "rules"]),
            _createVNode(_component_dc_form_item, {
              name: "customerRegion",
              label: _unref(t)('clue.customerRegion')
            }, {
              default: _withCtx(() => [
                _createVNode(CustomerAreaCascader, {
                  appId: "cos_ofbu",
                  value: dataForm.customerRegion,
                  "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((dataForm.customerRegion) = $event)),
                  disabled: !props.isEdit,
                  view: props.type === 'view'
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["label"]),
            (props.type !== 'view')
              ? (_openBlock(), _createBlock(_component_a_col, {
                  key: 1,
                  span: 6
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                      _createVNode(_component_a_form_item, {
                        style: {"width":"70%"},
                        label: _unref(t)('clue.estAveRevenue'),
                        name: ['business', 'annualSales']
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_CosInputNumber, {
                            value: dataForm.business.annualSales,
                            "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((dataForm.business.annualSales) = $event)),
                            maxlength: 15,
                            min: 0,
                            controls: false,
                            view: props.type === 'view',
                            cosType: "money",
                            formatter: (inputValue) => `${inputValue}`.replace(/\B(?=(\d{3})+(?!\d))/g, ','),
                            parser: (inputValue) => inputValue.replace(/\$\s?|(,*)/g, '')
                          }, null, 8, ["value", "view", "formatter", "parser"])
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      _createVNode(_component_a_form_item, {
                        label: "annualSalesUnit",
                        style: {"width":"30%"},
                        name: ['business', 'annualSalesUnit'],
                        class: "hide-label"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ParamCodesSelect, {
                            options: paramCodeData.ofbu_currency,
                            value: dataForm.business.annualSalesUnit,
                            "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((dataForm.business.annualSalesUnit) = $event)),
                            view: props.type === 'view'
                          }, null, 8, ["options", "value", "view"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_dc_form_item, {
                  key: 2,
                  label: _unref(t)('clue.estAveRevenue'),
                  name: ['business', 'annualSalesUnit']
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ParamCodesSelect, {
                      cosBeforeDes: dataForm.business?.annualSales?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','),
                      options: paramCodeData.ofbu_currency,
                      value: dataForm.business.annualSalesUnit,
                      "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((dataForm.business.annualSalesUnit) = $event)),
                      view: props.type === 'view'
                    }, null, 8, ["cosBeforeDes", "options", "value", "view"])
                  ]),
                  _: 1
                }, 8, ["label"])),
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('clue.clientType'),
              name: "clientType"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  options: paramCodeData.ofbu_client_type,
                  value: dataForm.clientType,
                  "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((dataForm.clientType) = $event)),
                  disabled: !props.isEdit,
                  view: props.type === 'view'
                }, null, 8, ["options", "value", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('clue.salesChannel'),
              name: ['business', 'salesChannel']
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  mode: "multiple",
                  options: paramCodeData.ofbu_sales_channel,
                  value: dataForm.business.salesChannel,
                  "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((dataForm.business.salesChannel) = $event)),
                  view: props.type === 'view',
                  disabled: !props.isEdit
                }, null, 8, ["options", "value", "view", "disabled"])
              ]),
              _: 1
            }, 8, ["label"]),
            (clueType.value)
              ? (_openBlock(), _createBlock(_component_dc_form_item, {
                  key: 3,
                  name: "futureContactTime",
                  label: _unref(t)('clue.futureContactTime'),
                  rules: clueType.value ? formRules.futureContactTime : []
                }, {
                  default: _withCtx(() => [
                    _createVNode(CosSingleDateTimePicker, {
                      isOutputBeijingTime: "",
                      startTime: dataForm.futureContactTime,
                      "onUpdate:startTime": _cache[16] || (_cache[16] = ($event: any) => ((dataForm.futureContactTime) = $event)),
                      isRange: false,
                      view: props.type === 'view'
                    }, null, 8, ["startTime", "view"])
                  ]),
                  _: 1
                }, 8, ["label", "rules"]))
              : _createCommentVNode("", true),
            _createVNode(_component_dc_form_item, {
              name: "follower",
              label: _unref(t)('clue.followerName')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_UserSelect, {
                  value: dataForm.follower,
                  "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((dataForm.follower) = $event)),
                  defaultValue: "me",
                  disabled: !props.isEdit,
                  view: props.type === 'view',
                  allowClear: "",
                  onChange: handleFollowerChange
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["label"]),
            (dataForm.clueType === 3)
              ? (_openBlock(), _createBlock(_component_dc_form_item, {
                  key: 4,
                  name: "invalidId",
                  label: _unref(t)('clue.invalidReason'),
                  rules: invalidClue.value ? formRules.invalidId : []
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ParamCodesSelect, {
                      value: dataForm.invalidId,
                      "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((dataForm.invalidId) = $event)),
                      options: paramCodeData.ofbu_invalid_reason,
                      disabled: !props.isEdit,
                      view: props.type === 'view',
                      allowClear: ""
                    }, null, 8, ["value", "options", "disabled", "view"])
                  ]),
                  _: 1
                }, 8, ["label", "rules"]))
              : _createCommentVNode("", true),
            (!props.isEdit)
              ? (_openBlock(), _createBlock(_component_dc_form_item, {
                  key: 5,
                  name: "createByName",
                  label: _unref(t)('common.createByName')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CosInput, {
                      value: dataForm.createByName,
                      "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((dataForm.createByName) = $event)),
                      view: ""
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true),
            (!props.isEdit)
              ? (_openBlock(), _createBlock(_component_dc_form_item, {
                  key: 6,
                  name: "createTime",
                  label: _unref(t)('common.createTime')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CosInput, {
                      value: dataForm.createTime,
                      "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((dataForm.createTime) = $event)),
                      view: ""
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["title"]),
        _createVNode(_component_dc_layout_card, {
          title: _unref(t)('common.concatInfo'),
          span: 6
        }, {
          default: _withCtx(() => [
            (props.type === 'view')
              ? (_openBlock(), _createBlock(_component_dc_form_item, {
                  key: 0,
                  label: _unref(t)('common.contactName'),
                  name: ['contact', 'lastName'],
                  rules: formRules.lastName
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CosInput, {
                      value: dataForm.contact.name,
                      "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => ((dataForm.contact.name) = $event)),
                      view: props.type === 'view'
                    }, null, 8, ["value", "view"])
                  ]),
                  _: 1
                }, 8, ["label", "rules"]))
              : (_openBlock(), _createBlock(_component_a_col, {
                  key: 1,
                  span: 6
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      _createVNode(_component_a_form_item, {
                        span: 24,
                        label: _unref(t)('common.firstName'),
                        style: {"width":"50%"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_CosInput, {
                            value: dataForm.contact.firstName,
                            "onUpdate:value": _cache[22] || (_cache[22] = ($event: any) => ((dataForm.contact.firstName) = $event)),
                            maxlength: 50
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      _createVNode(_component_a_form_item, {
                        label: _unref(t)('common.lastName'),
                        name: ['contact', 'lastName'],
                        style: {"width":"50%"},
                        class: "last-compact",
                        rules: formRules.lastName
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_CosInput, {
                            value: dataForm.contact.lastName,
                            "onUpdate:value": _cache[23] || (_cache[23] = ($event: any) => ((dataForm.contact.lastName) = $event)),
                            maxlength: 50
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      }, 8, ["label", "rules"])
                    ])
                  ]),
                  _: 1
                })),
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('common.mobile'),
              name: ['contact', 'mobileRegion'],
              class: "form-item_compact"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_group, {
                  compact: "",
                  class: "cos-view-input-group"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ParamCodesSelect, {
                      value: dataForm.contact.mobileRegion,
                      "onUpdate:value": _cache[24] || (_cache[24] = ($event: any) => ((dataForm.contact.mobileRegion) = $event)),
                      options: paramCodeData.ofbu_area_code,
                      disabled: !props.isEdit,
                      view: props.type === 'view',
                      cosDes: dataForm.contact.mobile,
                      allowClear: "",
                      style: {"width":"33%"}
                    }, null, 8, ["value", "options", "disabled", "view", "cosDes"]),
                    _createVNode(_component_dc_form_item, {
                      span: 24,
                      style: {"width":"67%"},
                      name: ['contact', 'mobile'],
                      rules: {
              validator: (rule, value) => _unref(ofbuContactValidate)(rule, value, dataForm.contact, formRef.value)
            },
                      class: "last-compact"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_CosInput, {
                          value: dataForm.contact.mobile,
                          "onUpdate:value": _cache[25] || (_cache[25] = ($event: any) => ((dataForm.contact.mobile) = $event)),
                          disabled: !props.isEdit,
                          view: props.type === 'view'
                        }, null, 8, ["value", "disabled", "view"])
                      ]),
                      _: 1
                    }, 8, ["rules"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('common.skype'),
              name: ['contact', 'skype'],
              rules: {
              validator: (rule, value) => _unref(ofbuContactValidate)(rule, value, dataForm.contact, formRef.value)
            }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosInput, {
                  value: dataForm.contact.skype,
                  "onUpdate:value": _cache[26] || (_cache[26] = ($event: any) => ((dataForm.contact.skype) = $event)),
                  maxlength: 100,
                  disabled: !props.isEdit,
                  view: props.type === 'view'
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["label", "rules"]),
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('common.email'),
              name: ['contact', 'email'],
              rules: {
              validator: (rule, value) => _unref(ofbuContactValidate)(rule, value, dataForm.contact, formRef.value)
            }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosInput, {
                  value: dataForm.contact.email,
                  "onUpdate:value": _cache[27] || (_cache[27] = ($event: any) => ((dataForm.contact.email) = $event)),
                  maxlength: 100,
                  disabled: !props.isEdit,
                  view: props.type === 'view'
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["label", "rules"]),
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('common.jobRole'),
              name: ['contact', 'tel']
            }, {
              default: _withCtx(() => [
                _createVNode(CosSelect, {
                  value: dataForm.contact.jobRole,
                  "onUpdate:value": _cache[28] || (_cache[28] = ($event: any) => ((dataForm.contact.jobRole) = $event)),
                  options: _unref(linkRoleTypeEnum),
                  disabled: !props.isEdit,
                  allowClear: "",
                  view: props.type === 'view'
                }, null, 8, ["value", "options", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('common.jobDuty'),
              name: ['contact', 'jobDuty']
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosInput, {
                  value: dataForm.contact.jobDuty,
                  "onUpdate:value": _cache[29] || (_cache[29] = ($event: any) => ((dataForm.contact.jobDuty) = $event)),
                  maxlength: 100,
                  disabled: !props.isEdit,
                  view: props.type === 'view'
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('common.sex'),
              name: ['contact', 'sex']
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosRadioGroup, {
                  value: dataForm.contact.sex,
                  "onUpdate:value": _cache[30] || (_cache[30] = ($event: any) => ((dataForm.contact.sex) = $event)),
                  options: _unref(genderEnum),
                  view: props.type === 'view'
                }, null, 8, ["value", "options", "view"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_a_col, { span: 24 }),
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('common.remark'),
              name: ['contact', 'remark'],
              span: 12
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosTextarea, {
                  value: dataForm.contact.remark,
                  "onUpdate:value": _cache[31] || (_cache[31] = ($event: any) => ((dataForm.contact.remark) = $event)),
                  maxlength: 2000,
                  disabled: !props.isEdit,
                  view: props.type === 'view'
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["title"]),
        _createVNode(_component_dc_layout_card, {
          title: _unref(t)('clue.业务需求'),
          span: 6
        }, {
          default: _withCtx(() => [
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('clue.业务类型'),
              name: ['business', 'businessTypeSelect']
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  value: dataForm.business.businessTypeSelect,
                  "onUpdate:value": _cache[32] || (_cache[32] = ($event: any) => ((dataForm.business.businessTypeSelect) = $event)),
                  options: paramCodeData.ofbu_business_type,
                  disabled: !props.isEdit,
                  view: props.type === 'view',
                  allowClear: "",
                  "max-tag-count": !props.isEdit ? 100 : 'responsive'
                }, null, 8, ["value", "options", "disabled", "view", "max-tag-count"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('clue.服务标准'),
              name: ['business',  'servicesStandard']
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  value: dataForm.business.servicesStandard,
                  "onUpdate:value": _cache[33] || (_cache[33] = ($event: any) => ((dataForm.business.servicesStandard) = $event)),
                  options: paramCodeData.ofbu_services_standard,
                  disabled: !props.isEdit,
                  view: props.type === 'view',
                  allowClear: "",
                  "max-tag-count": !props.isEdit ? 100 : 'responsive'
                }, null, 8, ["value", "options", "disabled", "view", "max-tag-count"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('clue.销售平台'),
              name: ['business', 'salePlatform']
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  value: dataForm.business.salePlatform,
                  "onUpdate:value": _cache[34] || (_cache[34] = ($event: any) => ((dataForm.business.salePlatform) = $event)),
                  options: paramCodeData.ofbu_sale_platform,
                  disabled: !props.isEdit,
                  view: props.type === 'view',
                  allowClear: "",
                  mode: "multiple",
                  "max-tag-count": !props.isEdit ? 100 : 'responsive'
                }, null, 8, ["value", "options", "disabled", "view", "max-tag-count"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('clue.发货量(月)'),
              name: ['business',  'shipments']
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  value: dataForm.business.shipments,
                  "onUpdate:value": _cache[35] || (_cache[35] = ($event: any) => ((dataForm.business.shipments) = $event)),
                  options: paramCodeData.ofbu_shipments,
                  disabled: !props.isEdit,
                  view: props.type === 'view',
                  allowClear: "",
                  "max-tag-count": !props.isEdit ? 100 : 'responsive'
                }, null, 8, ["value", "options", "disabled", "view", "max-tag-count"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('clue.产品分类'),
              name: ['business', 'salesCategory']
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  value: dataForm.business.salesCategory,
                  "onUpdate:value": _cache[36] || (_cache[36] = ($event: any) => ((dataForm.business.salesCategory) = $event)),
                  options: paramCodeData.ofbu_sales_category,
                  disabled: !props.isEdit,
                  view: props.type === 'view',
                  allowClear: "",
                  mode: "multiple",
                  "max-tag-count": !props.isEdit ? 100 : 'responsive'
                }, null, 8, ["value", "options", "disabled", "view", "max-tag-count"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('clue.产品尺寸'),
              name: ['business', 'cargoType']
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  value: dataForm.business.cargoType,
                  "onUpdate:value": _cache[37] || (_cache[37] = ($event: any) => ((dataForm.business.cargoType) = $event)),
                  options: paramCodeData.ofbu_product_type,
                  disabled: !props.isEdit,
                  view: props.type === 'view',
                  allowClear: "",
                  mode: "multiple",
                  "max-tag-count": !props.isEdit ? 100 : 'responsive'
                }, null, 8, ["value", "options", "disabled", "view", "max-tag-count"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_dc_form_item, {
              name: ['business', 'orderTypeDistribution'],
              label: _unref(t)('clue.订单类型分布')
            }, {
              label: _withCtx(() => [
                _createVNode(_component_a_tooltip, {
                  placement: "topLeft",
                  overlayStyle: { maxWidth: '800px' }
                }, {
                  title: _withCtx(() => [
                    _createElementVNode("p", null, _toDisplayString(_unref(t)('common.订单类型分布输入提示')), 1)
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(_unref(t)('clue.订单类型分布')), 1),
                    _createVNode(_unref(ExclamationCircleOutlined), { style: {"margin-left":"2px","font-size":"14px"} })
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_CosInput, {
                  value: dataForm.business.orderTypeDistribution,
                  "onUpdate:value": _cache[38] || (_cache[38] = ($event: any) => ((dataForm.business.orderTypeDistribution) = $event)),
                  valueModifiers: { trim: true },
                  maxlength: 200,
                  disabled: !props.isEdit,
                  placeholder: _unref(t)('common.订单类型分布输入提示'),
                  view: props.type === 'view'
                }, null, 8, ["value", "disabled", "placeholder", "view"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_dc_form_item, {
              name: ['business', 'productValue'],
              label: _unref(t)('clue.热销品价值(USD)')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosInput, {
                  value: dataForm.business.productValue,
                  "onUpdate:value": _cache[39] || (_cache[39] = ($event: any) => ((dataForm.business.productValue) = $event)),
                  valueModifiers: { trim: true },
                  maxlength: 200,
                  disabled: !props.isEdit,
                  view: props.type === 'view'
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_dc_form_item, {
              name: ['business', 'orderDistribution'],
              label: _unref(t)('clue.单品多品订单比例')
            }, {
              label: _withCtx(() => [
                _createVNode(_component_a_tooltip, {
                  placement: "topLeft",
                  overlayStyle: { maxWidth: '800px' }
                }, {
                  title: _withCtx(() => [
                    _createElementVNode("p", null, _toDisplayString(_unref(t)('common.单品多品订单比例输入提示')), 1)
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(_unref(t)('clue.单品多品订单比例')), 1),
                    _createVNode(_unref(ExclamationCircleOutlined), { style: {"margin-left":"2px","font-size":"14px"} })
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_CosInput, {
                  value: dataForm.business.orderDistribution,
                  "onUpdate:value": _cache[40] || (_cache[40] = ($event: any) => ((dataForm.business.orderDistribution) = $event)),
                  valueModifiers: { trim: true },
                  maxlength: 200,
                  disabled: !props.isEdit,
                  placeholder: _unref(t)('common.单品多品订单比例输入提示'),
                  view: props.type === 'view'
                }, null, 8, ["value", "disabled", "placeholder", "view"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_dc_form_item, {
              name: ['business', 'skuType'],
              label: _unref(t)('clue.SKU种类')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosInput, {
                  value: dataForm.business.skuType,
                  "onUpdate:value": _cache[41] || (_cache[41] = ($event: any) => ((dataForm.business.skuType) = $event)),
                  valueModifiers: { trim: true },
                  maxlength: 200,
                  disabled: !props.isEdit,
                  view: props.type === 'view'
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('clue.SKU单位'),
              name: ['business', 'skuUnit']
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  value: dataForm.business.skuUnit,
                  "onUpdate:value": _cache[42] || (_cache[42] = ($event: any) => ((dataForm.business.skuUnit) = $event)),
                  options: paramCodeData.ofbu_sku_unit,
                  disabled: !props.isEdit,
                  view: props.type === 'view',
                  allowClear: "",
                  mode: "multiple",
                  "max-tag-count": !props.isEdit ? 100 : 'responsive'
                }, null, 8, ["value", "options", "disabled", "view", "max-tag-count"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('clue.尾程服务需求'),
              name: ['business', 'serviceType']
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  value: dataForm.business.serviceType,
                  "onUpdate:value": _cache[43] || (_cache[43] = ($event: any) => ((dataForm.business.serviceType) = $event)),
                  options: paramCodeData.ofbu_service_type,
                  disabled: !props.isEdit,
                  view: props.type === 'view',
                  allowClear: "",
                  mode: "multiple",
                  "max-tag-count": !props.isEdit ? 100 : 'responsive'
                }, null, 8, ["value", "options", "disabled", "view", "max-tag-count"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('clue.区域仓'),
              name: ['business', 'regionalWarehouse']
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  value: dataForm.business.regionalWarehouse,
                  "onUpdate:value": _cache[44] || (_cache[44] = ($event: any) => ((dataForm.business.regionalWarehouse) = $event)),
                  options: paramCodeData.ofbu_demand_info,
                  disabled: !props.isEdit,
                  view: props.type === 'view',
                  allowClear: "",
                  mode: "multiple",
                  "max-tag-count": !props.isEdit ? 100 : 'responsive'
                }, null, 8, ["value", "options", "disabled", "view", "max-tag-count"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('clue.入库包装方式'),
              name: ['business', 'inboundPackageType']
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  value: dataForm.business.inboundPackageType,
                  "onUpdate:value": _cache[45] || (_cache[45] = ($event: any) => ((dataForm.business.inboundPackageType) = $event)),
                  options: paramCodeData.ofbu_inbound_package_type,
                  disabled: !props.isEdit,
                  view: props.type === 'view',
                  allowClear: "",
                  mode: "multiple",
                  "max-tag-count": !props.isEdit ? 100 : 'responsive'
                }, null, 8, ["value", "options", "disabled", "view", "max-tag-count"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_dc_form_item, {
              name: ['business', 'averageInventoryVolume'],
              label: _unref(t)('clue.平均在库体积')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosInput, {
                  value: dataForm.business.averageInventoryVolume,
                  "onUpdate:value": _cache[46] || (_cache[46] = ($event: any) => ((dataForm.business.averageInventoryVolume) = $event)),
                  valueModifiers: { trim: true },
                  maxlength: 200,
                  disabled: !props.isEdit,
                  view: props.type === 'view'
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_dc_form_item, {
              name: ['business', 'firstInboundTime'],
              label: _unref(t)('clue.预计第一次来货时间')
            }, {
              default: _withCtx(() => [
                _createVNode(CosSingleDateTimePicker, {
                  isOutputBeijingTime: "",
                  startTime: dataForm.business.firstInboundTime,
                  "onUpdate:startTime": _cache[47] || (_cache[47] = ($event: any) => ((dataForm.business.firstInboundTime) = $event)),
                  isRange: false,
                  view: props.type === 'view'
                }, null, 8, ["startTime", "view"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_dc_form_item, {
              name: ['business', 'futureIncrement'],
              label: _unref(t)('clue.未来增量(月订单)')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosInput, {
                  value: dataForm.business.futureIncrement,
                  "onUpdate:value": _cache[48] || (_cache[48] = ($event: any) => ((dataForm.business.futureIncrement) = $event)),
                  valueModifiers: { trim: true },
                  maxlength: 200,
                  disabled: !props.isEdit,
                  view: props.type === 'view'
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_dc_form_item, {
              name: ['business', 'systemIntegration'],
              label: _unref(t)('clue.系统对接需求')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosInput, {
                  value: dataForm.business.systemIntegration,
                  "onUpdate:value": _cache[49] || (_cache[49] = ($event: any) => ((dataForm.business.systemIntegration) = $event)),
                  valueModifiers: { trim: true },
                  maxlength: 200,
                  disabled: !props.isEdit,
                  placeholder: _unref(t)('common.系统对接需求输入提示'),
                  view: props.type === 'view'
                }, null, 8, ["value", "disabled", "placeholder", "view"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('clue.其他附件'),
              name: "otherFile",
              span: 24
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(UploadFile), {
                  view: props.type === 'view',
                  value: dataForm.business.otherFile,
                  "onUpdate:value": _cache[50] || (_cache[50] = ($event: any) => ((dataForm.business.otherFile) = $event)),
                  valueType: "array"
                }, null, 8, ["view", "value"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["title"]),
        _createVNode(_component_dc_layout_card, {
          title: _unref(t)('clue.报价'),
          span: 6
        }, _createSlots({
          default: _withCtx(() => [
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('clue.价格类型'),
              name: ['business','quotationInfo', 'quotationType']
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  value: dataForm.business.quotationInfo.quotationType,
                  "onUpdate:value": _cache[52] || (_cache[52] = ($event: any) => ((dataForm.business.quotationInfo.quotationType) = $event)),
                  options: paramCodeData.ofbu_quotation_type,
                  disabled: !props.isEdit,
                  view: props.type === 'view',
                  allowClear: "",
                  "max-tag-count": !props.isEdit ? 100 : 'responsive'
                }, null, 8, ["value", "options", "disabled", "view", "max-tag-count"])
              ]),
              _: 1
            }, 8, ["label"]),
            (quotationAndBusinessChange.value)
              ? (_openBlock(), _createBlock(_component_dc_form_item, {
                  key: 0,
                  name: ['business', 'quotationInfo', 'fulfillmentRatesVersion'],
                  label: _unref(t)('clue.仓储报价版本')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CosInput, {
                      value: dataForm.business.quotationInfo.fulfillmentRatesVersion,
                      "onUpdate:value": _cache[53] || (_cache[53] = ($event: any) => ((dataForm.business.quotationInfo.fulfillmentRatesVersion) = $event)),
                      valueModifiers: { trim: true },
                      maxlength: 200,
                      disabled: !props.isEdit,
                      view: props.type === 'view'
                    }, null, 8, ["value", "disabled", "view"])
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true),
            (quotationAndBusinessChange.value)
              ? (_openBlock(), _createBlock(_component_dc_form_item, {
                  key: 1,
                  name: ['business', 'quotationInfo', 'shippingRatesVersion'],
                  label: _unref(t)('clue.尾程报价版本')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CosInput, {
                      value: dataForm.business.quotationInfo.shippingRatesVersion,
                      "onUpdate:value": _cache[54] || (_cache[54] = ($event: any) => ((dataForm.business.quotationInfo.shippingRatesVersion) = $event)),
                      valueModifiers: { trim: true },
                      maxlength: 200,
                      disabled: !props.isEdit,
                      view: props.type === 'view'
                    }, null, 8, ["value", "disabled", "view"])
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true),
            (dataForm.business.quotationInfo.quotationType === 3469)
              ? (_openBlock(), _createBlock(_component_dc_form_item, {
                  key: 2,
                  name: ['business', 'quotationInfo', 'priceDocuments'],
                  label: _unref(t)('clue.报价策略'),
                  rules: { required: dataForm.business.quotationInfo.quotationType === 3469, message: _unref(t)('common.pleaseInput') }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CosInput, {
                      value: dataForm.business.quotationInfo.priceDocuments,
                      "onUpdate:value": _cache[55] || (_cache[55] = ($event: any) => ((dataForm.business.quotationInfo.priceDocuments) = $event)),
                      valueModifiers: { trim: true },
                      maxlength: 200,
                      disabled: !props.isEdit,
                      view: props.type === 'view'
                    }, null, 8, ["value", "disabled", "view"])
                  ]),
                  _: 1
                }, 8, ["label", "rules"]))
              : _createCommentVNode("", true),
            (quotationAndBusinessChange.value)
              ? (_openBlock(), _createBlock(MultipleItem, {
                  key: 3,
                  view: props.type === 'view'
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _createElementVNode("p", _hoisted_3, _toDisplayString(`${_unref(t)('clue.区域仓')}${_ctx.index+1}`), 1)
                      ]),
                      _: 1
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataForm.business.quotationInfo.details, (item, index) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                        _createVNode(_component_dc_form_item, {
                          label: _unref(t)('clue.区域仓'),
                          span: 3,
                          name: ['business', 'quotationInfo', 'details', index, 'regionalWarehouse']
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ParamCodesSelect, {
                              value: item.regionalWarehouse,
                              "onUpdate:value": ($event: any) => ((item.regionalWarehouse) = $event),
                              options: paramCodeData.ofbu_demand_info,
                              disabled: !props.isEdit,
                              view: props.type === 'view',
                              allowClear: ""
                            }, null, 8, ["value", "onUpdate:value", "options", "disabled", "view"])
                          ]),
                          _: 2
                        }, 1032, ["label", "name"]),
                        _createVNode(_component_dc_form_item, {
                          name: ['business', 'quotationInfo', 'details', index, 'subWarehouseCode'],
                          label: _unref(t)('clue.物理仓'),
                          span: 3
                        }, {
                          label: _withCtx(() => [
                            _createVNode(_component_a_tooltip, {
                              placement: "topLeft",
                              overlayStyle: { maxWidth: '800px' }
                            }, {
                              title: _withCtx(() => [
                                _hoisted_4
                              ]),
                              default: _withCtx(() => [
                                _createElementVNode("span", null, _toDisplayString(_unref(t)('clue.物理仓')), 1),
                                _createVNode(_unref(ExclamationCircleOutlined), { style: {"margin-left":"2px","font-size":"14px"} })
                              ]),
                              _: 1
                            })
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_CosInput, {
                              value: item.subWarehouseCode,
                              "onUpdate:value": ($event: any) => ((item.subWarehouseCode) = $event),
                              valueModifiers: { trim: true },
                              maxlength: 200,
                              disabled: "",
                              ignorePlaceHolder: "",
                              view: props.type === 'view'
                            }, null, 8, ["value", "onUpdate:value", "view"])
                          ]),
                          _: 2
                        }, 1032, ["name", "label"]),
                        _createVNode(_component_dc_form_item, {
                          name: ['business', 'quotationInfo', 'details', index, 'storageFeeDiscount'],
                          label: _unref(t)('clue.仓租折扣(%)'),
                          span: 3
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_CosInput, {
                              value: item.storageFeeDiscount,
                              "onUpdate:value": ($event: any) => ((item.storageFeeDiscount) = $event),
                              valueModifiers: { trim: true },
                              maxlength: 200,
                              disabled: !props.isEdit,
                              view: props.type === 'view'
                            }, null, 8, ["value", "onUpdate:value", "disabled", "view"])
                          ]),
                          _: 2
                        }, 1032, ["name", "label"]),
                        _createVNode(_component_dc_form_item, {
                          name: ['business', 'quotationInfo', 'details', index, 'handingFeeDiscount'],
                          label: _unref(t)('clue.操作费折扣(%)'),
                          span: 3
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_CosInput, {
                              value: item.handingFeeDiscount,
                              "onUpdate:value": ($event: any) => ((item.handingFeeDiscount) = $event),
                              valueModifiers: { trim: true },
                              maxlength: 200,
                              disabled: !props.isEdit,
                              view: props.type === 'view'
                            }, null, 8, ["value", "onUpdate:value", "disabled", "view"])
                          ]),
                          _: 2
                        }, 1032, ["name", "label"]),
                        _createVNode(_component_dc_form_item, {
                          name: ['business', 'quotationInfo', 'details', index, 'shippingFeeDiscount'],
                          label: _unref(t)('clue.尾程折扣(%)'),
                          span: 3
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_CosInput, {
                              value: item.shippingFeeDiscount,
                              "onUpdate:value": ($event: any) => ((item.shippingFeeDiscount) = $event),
                              valueModifiers: { trim: true },
                              maxlength: 200,
                              disabled: !props.isEdit,
                              view: props.type === 'view'
                            }, null, 8, ["value", "onUpdate:value", "disabled", "view"])
                          ]),
                          _: 2
                        }, 1032, ["name", "label"]),
                        _createVNode(_component_dc_form_item, {
                          name: ['business', 'quotationInfo', 'details', index, 'remark'],
                          label: _unref(t)('common.remark'),
                          span: 6
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_CosInput, {
                              value: item.remark,
                              "onUpdate:value": ($event: any) => ((item.remark) = $event),
                              maxlength: 2000,
                              disabled: !props.isEdit,
                              view: props.type === 'view'
                            }, null, 8, ["value", "onUpdate:value", "disabled", "view"])
                          ]),
                          _: 2
                        }, 1032, ["name", "label"]),
                        (
                  props.isEdit &&
                  dataForm.business.quotationInfo.details &&
                  dataForm.business.quotationInfo.details.length > 1
                )
                          ? (_openBlock(), _createBlock(_component_dc_form_item, {
                              key: 0,
                              span: 3
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_button, {
                                  type: "text",
                                  danger: "",
                                  style: {"padding":"0 0 0 12px"},
                                  onClick: ($event: any) => (handleQuotationDel(index))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(t)('btn.del')), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"])
                              ]),
                              _: 2
                            }, 1024))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["view"]))
              : _createCommentVNode("", true),
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('clue.客户报价/竞对报价'),
              name: ['business', 'quotationInfo', 'competitorPriceDocuments'],
              span: 24
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(UploadFile), {
                  view: props.type === 'view',
                  value: dataForm.business.quotationInfo.competitorPriceDocuments,
                  "onUpdate:value": _cache[56] || (_cache[56] = ($event: any) => ((dataForm.business.quotationInfo.competitorPriceDocuments) = $event)),
                  valueType: "array"
                }, null, 8, ["view", "value"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 2
        }, [
          (props.isEdit&&quotationAndBusinessChange.value)
            ? {
                name: "subTitle",
                fn: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    type: "primary",
                    ghost: "",
                    onClick: _cache[51] || (_cache[51] = ($event: any) => (handleQuotationAdd()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('btn.add')), 1)
                    ]),
                    _: 1
                  })
                ]),
                key: "0"
              }
            : undefined
        ]), 1032, ["title"]),
        _createVNode(_component_dc_layout_card, {
          title: _unref(t)('clue.合同和账期'),
          span: 6
        }, {
          default: _withCtx(() => [
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('clue.服务公司'),
              name: ['business', 'contractInfo', 'serviceCompany']
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  value: dataForm.business.contractInfo.serviceCompany,
                  "onUpdate:value": _cache[57] || (_cache[57] = ($event: any) => ((dataForm.business.contractInfo.serviceCompany) = $event)),
                  options: paramCodeData.ofbu_service_body,
                  disabled: !props.isEdit,
                  view: props.type === 'view',
                  allowClear: "",
                  "max-tag-count": !props.isEdit ? 100 : 'responsive'
                }, null, 8, ["value", "options", "disabled", "view", "max-tag-count"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('clue.付款方式'),
              name: ['business', 'contractInfo', 'paymentType']
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  value: dataForm.business.contractInfo.paymentType,
                  "onUpdate:value": _cache[58] || (_cache[58] = ($event: any) => ((dataForm.business.contractInfo.paymentType) = $event)),
                  options: paramCodeData.ofbu_payment_type,
                  disabled: !props.isEdit,
                  view: props.type === 'view',
                  allowClear: "",
                  "max-tag-count": !props.isEdit ? 100 : 'responsive'
                }, null, 8, ["value", "options", "disabled", "view", "max-tag-count"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('clue.出账周期(天)'),
              name: ['business', 'contractInfo', 'billingTerm']
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  value: dataForm.business.contractInfo.billingTerm,
                  "onUpdate:value": _cache[59] || (_cache[59] = ($event: any) => ((dataForm.business.contractInfo.billingTerm) = $event)),
                  options: paramCodeData.ofbu_billing_term,
                  disabled: !props.isEdit,
                  view: props.type === 'view',
                  allowClear: "",
                  "max-tag-count": !props.isEdit ? 100 : 'responsive'
                }, null, 8, ["value", "options", "disabled", "view", "max-tag-count"])
              ]),
              _: 1
            }, 8, ["label"]),
            (dataForm.business.contractInfo.paymentType === 3504
         || dataForm.business.contractInfo.paymentType === 3473)
              ? (_openBlock(), _createBlock(_component_dc_form_item, {
                  key: 0,
                  name: ['business', 'contractInfo', 'paymentTerm'],
                  label: _unref(t)('clue.付款周期(天)'),
                  rules: { required: dataForm.business.contractInfo.paymentType === 3473, message: _unref(t)('common.pleaseInput') }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CosInput, {
                      value: dataForm.business.contractInfo.paymentTerm,
                      "onUpdate:value": _cache[60] || (_cache[60] = ($event: any) => ((dataForm.business.contractInfo.paymentTerm) = $event)),
                      valueModifiers: { trim: true },
                      maxlength: 200,
                      disabled: !props.isEdit,
                      view: props.type === 'view'
                    }, null, 8, ["value", "disabled", "view"])
                  ]),
                  _: 1
                }, 8, ["label", "rules"]))
              : _createCommentVNode("", true),
            (props.type !== 'view' && dataForm.business.contractInfo.paymentType === 3504)
              ? (_openBlock(), _createBlock(_component_a_col, {
                  key: 1,
                  span: 6
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_a_form_item, {
                        style: {"width":"70%"},
                        label: _unref(t)('clue.固定额度'),
                        name: ['business', 'contractInfo', 'fixedCredit', 'amount'],
                        rules: { required: dataForm.business.contractInfo.paymentType === 3504, message: _unref(t)('common.pleaseInput') }
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_CosInputNumber, {
                            value: dataForm.business.contractInfo.fixedCredit.amount,
                            "onUpdate:value": _cache[61] || (_cache[61] = ($event: any) => ((dataForm.business.contractInfo.fixedCredit.amount) = $event)),
                            maxlength: 15,
                            min: 0,
                            controls: false,
                            view: props.type === 'view',
                            cosType: "money",
                            formatter: (inputValue) => `${inputValue}`.replace(/\B(?=(\d{3})+(?!\d))/g, ','),
                            parser: (inputValue) => inputValue.replace(/\$\s?|(,*)/g, '')
                          }, null, 8, ["value", "view", "formatter", "parser"])
                        ]),
                        _: 1
                      }, 8, ["label", "rules"]),
                      _createVNode(_component_a_form_item, {
                        label: "fixedCreditCurrency",
                        style: {"width":"30%"},
                        name: ['business', 'contractInfo', 'fixedCredit', 'currency'],
                        class: "hide-label",
                        rules: { required: dataForm.business.contractInfo.paymentType === 3504, message: _unref(t)('common.pleaseSelect') }
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ParamCodesSelect, {
                            options: paramCodeData.ofbu_currency,
                            value: dataForm.business.contractInfo.fixedCredit.currency,
                            "onUpdate:value": _cache[62] || (_cache[62] = ($event: any) => ((dataForm.business.contractInfo.fixedCredit.currency) = $event)),
                            view: props.type === 'view'
                          }, null, 8, ["options", "value", "view"])
                        ]),
                        _: 1
                      }, 8, ["rules"])
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (props.type === 'view' && dataForm.business.contractInfo.paymentType === 3504)
              ? (_openBlock(), _createBlock(_component_dc_form_item, {
                  key: 2,
                  label: _unref(t)('clue.固定额度'),
                  name: ['business', 'contractInfo', 'fixedCredit', 'currency'],
                  rules: [{ required: dataForm.business.contractInfo.paymentType === 3504, message: _unref(t)('common.pleaseSelect') }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ParamCodesSelect, {
                      cosBeforeDes: dataForm.business.contractInfo.fixedCredit.amount?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','),
                      options: paramCodeData.ofbu_currency,
                      value: dataForm.business.contractInfo.fixedCredit.currency,
                      "onUpdate:value": _cache[63] || (_cache[63] = ($event: any) => ((dataForm.business.contractInfo.fixedCredit.currency) = $event)),
                      view: props.type === 'view'
                    }, null, 8, ["cosBeforeDes", "options", "value", "view"])
                  ]),
                  _: 1
                }, 8, ["label", "rules"]))
              : _createCommentVNode("", true),
            (props.type !== 'view')
              ? (_openBlock(), _createBlock(_component_a_col, {
                  key: 3,
                  span: 6
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_a_form_item, {
                        style: {"width":"70%"},
                        label: _unref(t)('clue.系统注册费'),
                        name: ['business', 'contractInfo', 'registrationFee', 'amount']
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_CosInputNumber, {
                            value: dataForm.business.contractInfo.registrationFee.amount,
                            "onUpdate:value": _cache[64] || (_cache[64] = ($event: any) => ((dataForm.business.contractInfo.registrationFee.amount) = $event)),
                            maxlength: 15,
                            min: 0,
                            controls: false,
                            view: props.type === 'view',
                            cosType: "money",
                            formatter: (inputValue) => `${inputValue}`.replace(/\B(?=(\d{3})+(?!\d))/g, ','),
                            parser: (inputValue) => inputValue.replace(/\$\s?|(,*)/g, '')
                          }, null, 8, ["value", "view", "formatter", "parser"])
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      _createVNode(_component_a_form_item, {
                        label: "registrationFeeCurrency",
                        style: {"width":"30%"},
                        name: ['business', 'contractInfo', 'registrationFee', 'currency' ],
                        class: "hide-label"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ParamCodesSelect, {
                            options: paramCodeData.ofbu_currency,
                            value: dataForm.business.contractInfo.registrationFee.currency,
                            "onUpdate:value": _cache[65] || (_cache[65] = ($event: any) => ((dataForm.business.contractInfo.registrationFee.currency) = $event)),
                            view: props.type === 'view'
                          }, null, 8, ["options", "value", "view"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_dc_form_item, {
                  key: 4,
                  label: _unref(t)('clue.系统注册费'),
                  name: ['business', 'contractInfo', 'registrationFee', 'currency']
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ParamCodesSelect, {
                      cosBeforeDes: dataForm.business.contractInfo.registrationFee.amount?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','),
                      options: paramCodeData.ofbu_currency,
                      value: dataForm.business.contractInfo.registrationFee.currency,
                      "onUpdate:value": _cache[66] || (_cache[66] = ($event: any) => ((dataForm.business.contractInfo.registrationFee.currency) = $event)),
                      view: props.type === 'view'
                    }, null, 8, ["cosBeforeDes", "options", "value", "view"])
                  ]),
                  _: 1
                }, 8, ["label"])),
            (props.type !== 'view')
              ? (_openBlock(), _createBlock(_component_a_col, {
                  key: 5,
                  span: 6
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_a_form_item, {
                        style: {"width":"70%"},
                        label: _unref(t)('clue.系统管理月费'),
                        name: ['business', 'contractInfo', 'monthlyMaintenanceFee', 'amount']
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_CosInputNumber, {
                            value: dataForm.business.contractInfo.monthlyMaintenanceFee.amount,
                            "onUpdate:value": _cache[67] || (_cache[67] = ($event: any) => ((dataForm.business.contractInfo.monthlyMaintenanceFee.amount) = $event)),
                            maxlength: 15,
                            min: 0,
                            controls: false,
                            view: props.type === 'view',
                            cosType: "money",
                            formatter: (inputValue) => `${inputValue}`.replace(/\B(?=(\d{3})+(?!\d))/g, ','),
                            parser: (inputValue) => inputValue.replace(/\$\s?|(,*)/g, '')
                          }, null, 8, ["value", "view", "formatter", "parser"])
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      _createVNode(_component_a_form_item, {
                        label: "monthlyMaintenanceFeeCurrency",
                        style: {"width":"30%"},
                        name: ['business', 'contractInfo', 'monthlyMaintenanceFee', 'currency'],
                        class: "hide-label"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ParamCodesSelect, {
                            options: paramCodeData.ofbu_currency,
                            value: dataForm.business.contractInfo.monthlyMaintenanceFee.currency,
                            "onUpdate:value": _cache[68] || (_cache[68] = ($event: any) => ((dataForm.business.contractInfo.monthlyMaintenanceFee.currency) = $event)),
                            view: props.type === 'view'
                          }, null, 8, ["options", "value", "view"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_dc_form_item, {
                  key: 6,
                  label: _unref(t)('clue.系统管理月费'),
                  name: ['business', 'contractInfo', 'monthlyMaintenanceFee', 'currency']
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ParamCodesSelect, {
                      cosBeforeDes: dataForm.business.contractInfo.monthlyMaintenanceFee.amount?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','),
                      options: paramCodeData.ofbu_currency,
                      value: dataForm.business.contractInfo.monthlyMaintenanceFee.currency,
                      "onUpdate:value": _cache[69] || (_cache[69] = ($event: any) => ((dataForm.business.contractInfo.monthlyMaintenanceFee.currency) = $event)),
                      view: props.type === 'view'
                    }, null, 8, ["cosBeforeDes", "options", "value", "view"])
                  ]),
                  _: 1
                }, 8, ["label"])),
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('clue.客户特殊服务'),
              name: ['business', 'contractInfo', 'additionalServices']
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  value: dataForm.business.contractInfo.additionalServices,
                  "onUpdate:value": _cache[70] || (_cache[70] = ($event: any) => ((dataForm.business.contractInfo.additionalServices) = $event)),
                  options: paramCodeData.ofbu_service_demand,
                  disabled: !props.isEdit,
                  view: props.type === 'view',
                  allowClear: "",
                  mode: "multiple",
                  "max-tag-count": !props.isEdit ? 100 : 'responsive'
                }, null, 8, ["value", "options", "disabled", "view", "max-tag-count"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_dc_form_item, {
              name: ['business', 'contractInfo', 'legalSystemApplicationNo'],
              label: _unref(t)('clue.法务流程编码')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosInput, {
                  value: dataForm.business.contractInfo.legalSystemApplicationNo,
                  "onUpdate:value": _cache[71] || (_cache[71] = ($event: any) => ((dataForm.business.contractInfo.legalSystemApplicationNo) = $event)),
                  valueModifiers: { trim: true },
                  maxlength: 200,
                  disabled: !props.isEdit,
                  view: props.type === 'view'
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_a_col, { span: 24 }),
            _createVNode(_component_dc_form_item, {
              name: "remark",
              label: _unref(t)('common.remark'),
              span: 12
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosTextarea, {
                  value: dataForm.remark,
                  "onUpdate:value": _cache[72] || (_cache[72] = ($event: any) => ((dataForm.remark) = $event)),
                  maxlength: 2000,
                  disabled: !props.isEdit,
                  view: props.type === 'view'
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["title"])
      ]),
      _: 1
    }, 8, ["model"]),
    _createVNode(_component_cos_footer_button, {
      value: dataForm,
      "onUpdate:value": _cache[73] || (_cache[73] = ($event: any) => ((dataForm) = $event)),
      formRef: formRef.value,
      resetValue: __props.resetValue,
      loading: loading.value,
      disabled: !props.isEdit,
      permissionPage: permissionPage.value,
      onSubmit: handleSubmit
    }, null, 8, ["value", "formRef", "resetValue", "loading", "disabled", "permissionPage"])
  ], 64))
}
}

})